export default "__VITE_ASSET__jH_nw7cR__"